import sliderCss from 'blaze-slider/dist/blaze.css?url'

import {createFileRoute, notFound} from '@tanstack/react-router'
import imageUrlBuilder from '@sanity/image-url'
import getHomePageContent from '~/client/fn/homePageContent'
import HomePageContent from '~/components/home/Content'
import {shopQueryOptions} from '~/client/fn/shop'
import seo from '~/utils/seo'

export const Route = createFileRoute('/$lang/_layout/')({
    component: RouteComponent,
    loader: async ({context}) => {
        const [pageContent, shopData] = await Promise.all([
            getHomePageContent({data: {locale: context.locale}}),
            context.queryClient.ensureQueryData(shopQueryOptions()),
        ])

        if (!pageContent || !shopData) {
            throw notFound()
        }

        return {
            pageContent,
            shopData,
        }
    },
    head: ({loaderData}) => {
        if (!loaderData?.pageContent?.seo) {
            return {
                links: [
                    {
                        rel: 'preload',
                        href: sliderCss,
                        as: 'style',
                    },
                    {
                        rel: 'stylesheet',
                        href: sliderCss,
                    },
                ],
            }
        }

        const seoData = loaderData.pageContent.seo
        const builder = imageUrlBuilder({...loaderData.shopData.cms})
        const metaTags = seo({
            title: seoData.title,
            description: seoData.description,
            image: seoData.image
                ? {
                      src: builder.image(seoData.image).width(500).height(250).url(),
                      width: 500,
                      height: 250,
                  }
                : undefined,
        })

        return {
            meta: metaTags.length > 0 ? metaTags : undefined,
            links: [
                {
                    rel: 'preload',
                    href: sliderCss,
                    as: 'style',
                },
                {
                    rel: 'stylesheet',
                    href: sliderCss,
                },
            ],
        }
    },
})

function RouteComponent() {
    const {pageContent} = Route.useLoaderData()

    return (
        <div className="pb-6 lg:pb-12 mx-auto max-w-[1920px]">
            <h1 className="sr-only">{pageContent?.seo?.title ?? 'Gravity Shirts'}</h1>
            <div className="space-y-8 sm:space-y-12 md:space-y-16">
                {!!pageContent?.elements && <HomePageContent elements={pageContent.elements} />}
            </div>
        </div>
    )
}
